import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { StoreContext } from "components/StoreContext";
import { CartContext } from "components/CartContext";
import { GetQuoteButton } from "components/Products/searchResultButtons";
import headerDotGrid from "../../../components/Images/headerDotGrid.svg";
import Bundle from "../../../components/Bundle";
import PartnerLink from "./partnerLink";
import { InCartButton, AddToCartButton } from "./cardButtons";
import EnterpriseLicenseInfo from "./enterpriseLicenseInfo";
import {
  EnterprisePricingComponent,
  NormalPricingComponent
} from "./pricingComponent";

// eslint-disable-next-line object-curly-newline
const Header = ({
  bundleCount,
  credits,
  parentCategory,
  provider,
  name,
  partner,
  id,
  sku,
  price,
  discountPrice,
  purchasable,
  showPrice,
  imageLargePath
}) => {
  const { StoreAPI } = useContext(StoreContext);
  const [nameSEO, updateNameSEO] = useState(null);
  const { cart, onCartAdd } = useContext(CartContext);
  const [added, setAdded] = useState(false);
  const found = cart.items.find(o => o.sku === sku);

  const backgroundImage = {
    backgroundImage: `url(${imageLargePath})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "0"
  };

  const dotBackgroundImage = {
    backgroundImage: `url(${headerDotGrid})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "0"
  };

  useEffect(() => {
    StoreAPI.get(`partners/search?partnercode=${partner}`)
      .then(response => {
        updateNameSEO(response.data.nameSEO);
      })
      .catch(error => {
        console.log(error);
      }, []);
  }, [StoreAPI, partner]);

  return (
    <div
      className={`productPage__header productPage__header--${parentCategory}`}
    >
      <div className="productPage__header__wrapper">
        <div className="col-sm-7">
          <h1 className="productPage__header__wrapper--productName">{name}</h1>
          <div className="productPage__header__wrapper--bundleCount">
            <Bundle bundleCount={bundleCount} />
            {credits > 0 ? (
              <div className="ceCircle">
                <span className="ceCircle__circle">CE</span>
                <span>
                  {credits}
                  &nbsp;CERE
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {provider && <PartnerLink provider={provider} nameSEO={nameSEO} />}
          {!showPrice && (
            <EnterpriseLicenseInfo name={name} sku={sku} showLicenseInfo />
          )}
          {!purchasable && showPrice && (
            <div className="productPrice">
              <p className="productPrice--licenseInfo" id="licenseInfo">
                This Product cannot be purchased as an individual license.
              </p>
              <EnterprisePricingComponent
                price={price}
                discountPrice={discountPrice}
              />
              <GetQuoteButton name={name} sku={sku} />
            </div>
          )}
          {purchasable && showPrice && (
            <>
              <div className="productPrice">
                <NormalPricingComponent
                  price={price}
                  discountPrice={discountPrice}
                />
              </div>
              <div className="addToCartQuoteBlock">
                {found || added ? (
                  <InCartButton />
                ) : (
                  <AddToCartButton
                    onCartAdd={onCartAdd}
                    sku={sku}
                    id={id}
                    price={price}
                    setAdded={setAdded}
                  />
                )}
                <EnterpriseLicenseInfo name={name} sku={sku} />
              </div>
            </>
          )}
        </div>
        {imageLargePath ? (
          <div
            style={backgroundImage}
            className="productPage__header__wrapper--partnerImage col-5"
            alt={imageLargePath}
          >
            <div className="gradientOverlay" />
          </div>
        ) : (
          <div
            style={dotBackgroundImage}
            className="productPage__header__wrapper--dotImage col-5"
            alt="dot grid"
          />
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  bundleCount: PropTypes.number,
  credits: PropTypes.number,
  parentCategory: PropTypes.number,
  provider: PropTypes.string,
  name: PropTypes.string,
  partner: PropTypes.string,
  price: PropTypes.number,
  discountPrice: PropTypes.number,
  sku: PropTypes.string.isRequired,
  purchasable: PropTypes.bool,
  showPrice: PropTypes.bool,
  id: PropTypes.number,
  imageLargePath: PropTypes.string
};

Header.defaultProps = {
  bundleCount: null,
  credits: null,
  parentCategory: null,
  provider: null,
  name: " ",
  partner: null,
  price: null,
  discountPrice: null,
  purchasable: null,
  showPrice: undefined,
  id: null,
  imageLargePath: null
};

export default Header;
